import React, { FC } from 'react';
import { DocumentCardProps } from './types';
import { getExtensionIconData } from './utils';
import { GenericDocumentLink } from './DocumentCardButtons';

const DocumentCardExtensionIcon: FC<Pick<DocumentCardProps, 'extension' | 'url' | 'onNavigate'>> = ({
	extension,
	url,
	onNavigate,
}) => {
	const { Icon, fill } = getExtensionIconData(extension);
	const documentIcon = (
		<Icon
			fill={fill}
			width='56px'
			height='56px'
		/>
	);

	return (
		<GenericDocumentLink
			url={url}
			onNavigate={onNavigate}
		>
			{documentIcon}
		</GenericDocumentLink>
	);
};

export { DocumentCardExtensionIcon };
